import React from 'react';

import styled from 'styled-components';

const SidebarTooltip = styled.div.withConfig({ displayName: 'SidebarTooltip' })`
  .tooltip{
    display: none;
    position: absolute;

    height: 40px;

    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.16));
    background: #5F6FDA;
    border-radius: 8px;
    padding-top: 8px;
    padding-right: 12px;
    padding-bottom: 8px;
    padding-left: 12px;

    text-align: left;


    color: white;


    font-family: Poppins;
    font-weight: 500;
    font-style: Medium;
    font-size: 12px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0%;
    text-align: center;


    left: 53px;
    width: auto;
    height: 40px;
    min-width: 40px;
    white-space: nowrap;


    justify-content: center;
    align-items: center;

    z-index: 99999;

  }

  .tooltip .arrow {
    position: absolute;
    left: -6px;
    height: 100%;
    display: flex;
    align-items: center;
  }

  &:hover .tooltip {
    display: flex;
  }

  & {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;


    justify-content: center;
    align-items: center;
  }
`;


/* Tooltip */
export class BarToolTip extends React.Component {
  render() {
    return (
      <SidebarTooltip>
        <div className="tooltip">
          <span className="arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
              <path d="M8.51471 14.0711C8.51471 14.962 7.43757 15.4081 6.8076 14.7782L0.736529 8.7071C0.346004 8.31658 0.346005 7.68342 0.736529 7.29289L6.8076 1.22183C7.43757 0.591867 8.51471 1.03803 8.51471 1.92894L8.51471 14.0711Z" fill="#5F6FDA" />
            </svg>
          </span>
          {this.props.title}
        </div>
        {this.props.children}
      </SidebarTooltip>
    );
  }
}
